import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { fetchSurveyDetailsByID } from '../Details/details-store/details-actions';
import { fetchSurveyDefintionListByID } from './design-store/design-actions';
import EditTranslations from './Translations/edit-translations';
import Design from './Design';
import { useHistory, useParams } from 'react-router-dom';

const DesignerPage = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { userLoginDetails } = useSelector((state) => state.login);
    const { currentSurveyID } = useSelector((state) => state.projectList);
    const { showTranslationPage } = useSelector((state) => state.designDetails);


    useEffect(() => {
        if (id && userLoginDetails.user_id) {
            if (!currentSurveyID) {
                dispatch(fetchSurveyDetailsByID(`${id}/${userLoginDetails.user_id}`))
                    .then(() => {
                        dispatch(fetchSurveyDefintionListByID(`${id}/${userLoginDetails.user_id}`));
                    })
                    .catch((error) => {
                        // Handle error if fetchSurveyDetailsByID fails
                    });
            } else {
                dispatch(fetchSurveyDefintionListByID(`${id}/${userLoginDetails.user_id}`));
            }
        }
    }, [id, userLoginDetails.user_id]);
    return (
        showTranslationPage === true ? <EditTranslations /> : <Design />
    )
}

export default DesignerPage